import { useTranslation } from 'react-i18next';

const rows = [
  { area: 'home.check.r1.area', what: 'home.check.r1.what', why: 'home.check.r1.why' },
  { area: 'home.check.r2.area', what: 'home.check.r2.what', why: 'home.check.r2.why' },
  { area: 'home.check.r3.area', what: 'home.check.r3.what', why: 'home.check.r3.why' },
  { area: 'home.check.r4.area', what: 'home.check.r4.what', why: 'home.check.r4.why' },
  { area: 'home.check.r5.area', what: 'home.check.r5.what', why: 'home.check.r5.why' },
  { area: 'home.check.r6.area', what: 'home.check.r6.what', why: 'home.check.r6.why' },
];

export default function Checklist() {
  const { t } = useTranslation();

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-5xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t('home.checklistTitle')}
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{t('home.checklistSub')}</p>
        </div>

        <div className="mt-10 overflow-x-auto">
          <table className="w-full min-w-[560px] border-collapse text-left text-sm">
            <thead>
              <tr className="border-b border-background-300">
                <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-900">{t('home.checkArea')}</th>
                <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-900">{t('home.checkWhat')}</th>
                <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-900">{t('home.checkWhy')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.area} className="border-b border-background-200 last:border-0">
                  <td className="whitespace-nowrap px-4 py-3 font-medium text-primary-700">{t(r.area)}</td>
                  <td className="px-4 py-3 text-foreground-700">{t(r.what)}</td>
                  <td className="px-4 py-3 text-foreground-600">{t(r.why)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}